<template>
	<div class="container_head ">
		<van-form @submit="onSubmit">
			<van-cell-group style="margin-top: 5px;">
				<van-cell title="头像" center>
					<template #right-icon>
						<van-image width="70" height="70" round fit="cover" :src="userInfo.headimgUrl||defaultImg" />
					</template>
				</van-cell>
				<van-field v-model="userInfo.trueName" label="姓名" input-align="right"   readonly  :rules="[{ required: true, message: '必填' }]"  />
				<van-field v-model="userInfo.cardId" label="身份证号" input-align="right" readonly :rules="[{validator:validator2, message: '身份证不正确' }]" />
				<van-field v-model="userInfo.phone" label="手机号" input-align="right" readonly   name="phone" :rules="[{ validator, message: '手机号不正确' }]" />
			<!-- 	<template v-for="(item,i) in userInfo.houses">
						<van-field v-model="item.communityName" label="小区名称" input-align="right"  readonly   />
						<van-field v-model="item.address" label="房屋地址" input-align="right"  readonly autosize type="textarea"  />
				</template> -->
			
			<!-- 	<van-field v-model="xqdz" is-link readonly label="房屋信息" placeholder="请选择房屋所在地址"  name="xqdz"
					@click="show = true" :rules="[{ required: true, message: '必填' }]"   input-align="right" />
				<van-popup v-model="show" round position="bottom">
					<van-cascader v-model="cascaderValue" title="请选择所在小区" :options="options" @close="show = false"
						@change="onChange" @finish="onFinish" />
				</van-popup> -->
				<!-- <div style="margin: 16px;">
					<van-button round block type="info" native-type="submit">修改</van-button>
				</div> -->
			</van-cell-group>
		</van-form>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Image as VanImage,Cascader
	} from 'vant';
	Vue.use(VanImage).use(Cascader);
	import {
		mapState,
		mapMutations
	} from "vuex";
	import {
		Field
	} from 'vant';
	Vue.use(Field);
	export default {
		data() {
			return {
				defaultImg:require('../../assets/grzx/head.png'),
				show: false,
				xqdz: '阳光小区/1栋',
				cascaderValue: '1栋',
				options: [{
					text: '阳光小区',
					value: '阳光小区',
					children: [{
							text: '1栋',
							value: '1栋',
							children: [{
									text: '101',
									value: '101'
								},
								{
									text: '202',
									value: '202'
								}
							],
						},
						{
							text: '2栋',
							value: '2栋'
						}
					],
				}, {
					text: '测试小区',
					value: '测试小区',
				}],
			};
		},
		computed: {
			...mapState(['userInfo','identity']),
		},
		mounted() {
			
		},
		methods: {
			...mapMutations(['changeIdentity','changeUserinfo']),
			changeview(path) {
				this.$router.push(path);
			},
			onChange({
				value,
				selectedOptions,
				tabIndex
			}) {
				console.log(value, selectedOptions, tabIndex)
			},
			onFinish({
				selectedOptions
			}) {
				this.show = false;
				this.xqdz = selectedOptions.map((option) => option.text).join('/');
				console.log(this.cascaderValue)
			},
			validator(val) {
				return /^1(3|4|5|7|8)\d{9}$/.test(val);
			},
			validator2(val) {
				return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
			},
			onSubmit(values) {
				console.log(values);
				this.$axios.post('/api/v1/wechat/user/changePhone',values).then(res=>{
					this.$axios.get('/api/v2/wechat/user/userInfo', {
						params: {}
					}).then(res => {
						this.changeUserinfo(res)
						this.$dialog({ message: '修改成功' }).then(() => {
							this.$router.go(-1)
						});
					})
				})
			},
			
		}
	};
</script>

<style lang="less" scoped>
	.flexcenter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.qrxg{
		padding: 40px;
	}
</style>
